export const GET_EXPORT = "getExport";
export const GET_CERTIFICATES = "getCertificates";
export const GET_ALL_CERTIFICATES = "getAllCertificates";
export const GET_ISO ="getIso";
export const GET_CE ="getCE";
export const GET_STANDARD ="getStandard";
export const GET_GIFTS ="getGifts";
export const GET_COMMENDATION ="getCommendation";
export const GET_ABOUT_COMPANY = "getAboutCompany";
export const GET_ABOUT_COMPANY_BANNER = "getAboutCompanyBanner";
export const GET_MANAGEMENT = "getManagement";
export const GET_CONTACT_US = "getContactUs";
export const POST_CONTACT_US = "PostContactUs";